import { useEffect, useState } from 'react';
import { useAppSelector } from '../hooks/useAppSelector';
import * as userSlice from '../data/user.slice';

export const useIsOnboardingUser = (): boolean | undefined => {
  const [isOnboarding, setIsOnboarding] = useState<boolean>();
  const user = useAppSelector(userSlice.selectUserInfo);
  useEffect(() => {
    if (!!user?.onboardingUser) {
      setIsOnboarding(true);
    }
  }, [user]);

  return isOnboarding;
};
